import getConfig from "@/utils/getConfig";
import { ChallengesApi, GetChallengesResponse, GetChallengesSort, SortOrder, Token } from "@devour/client";
import { useSelector } from "react-redux";
import { IStore } from "@/redux/defaultStore";
import { useQuery } from "@tanstack/react-query";

interface ActiveChallengesParams {
    limit?: number;
    featured?: boolean;
}

async function fetchActiveChallenges(
    params: ActiveChallengesParams,
    fullToken?: Token,
): Promise<GetChallengesResponse> {
    const api = new ChallengesApi(getConfig(fullToken));

    return await api.getChallenges({
        limit: params.limit || 10,
        sort: GetChallengesSort.STARTDATE,
        order: SortOrder.Desc,
        // Only get active challenges (not ended)
        allowNonActives: false,
    });
}

function getActiveChallengesQuery(params: ActiveChallengesParams = {}) {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    return {
        queryKey: ["challenges", "active", params.limit, fullToken?.id ?? "unauthenticated"],
        queryFn: () => fetchActiveChallenges(params, fullToken),
        staleTime: 5 * 60000, // 5 minutes
    } as const;
}

export function useGetActiveChallenges(params: ActiveChallengesParams = {}) {
    return useQuery(getActiveChallengesQuery(params));
}